"use strict";
var timepicker_component_1 = require('./timepicker/timepicker.component');
exports.TimepickerComponent = timepicker_component_1.TimepickerComponent;
var timepicker_module_1 = require('./timepicker/timepicker.module');
exports.TimepickerModule = timepicker_module_1.TimepickerModule;



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/ng2-bootstrap/components/timepicker.js
// module id = ../../../../ng2-bootstrap/components/timepicker.js
// module chunks = 3